import { render, staticRenderFns } from "./weixinmingxi.vue?vue&type=template&id=d7b7fc3e&"
import script from "./weixinmingxi.vue?vue&type=script&lang=js&"
export * from "./weixinmingxi.vue?vue&type=script&lang=js&"
import style0 from "./weixinmingxi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports